import {useContext} from "react";
import MultiBookingDialogContext from "../context/MultiBookingDialogContext";

export const useMultiBookingDialogContext = () => useContext(MultiBookingDialogContext)